import "../../../node_modules/@coreui/coreui/dist/js/coreui.bundle.min";
